import { render, staticRenderFns } from "./opticians.vue?vue&type=template&id=eb60cfe8"
import script from "./opticians.vue?vue&type=script&lang=js"
export * from "./opticians.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports